import { Tooltip } from '@material-ui/core';
import { ToggleButton, ToggleButtonGroup } from '@material-ui/lab';
import { capitalize } from 'lodash';
import { AlignCenter, AlignLeft, AlignRight } from 'lucide-react';
import { useUnsafeTranslation } from '../../i18next';
import { CustomInputLabel } from '../CustomInputLabel';

export const TextAlignToggleButtonGroup = ({
  value = 'left',
  onChange
}: {
  value?: 'left' | 'center' | 'right';
  onChange: (nextValue: 'left' | 'center' | 'right') => void;
}) => {
  const { t } = useUnsafeTranslation();
  return (
    <ToggleButtonGroup
      exclusive
      aria-label="text alignment"
      value={value}
      onChange={(ev, nextAlign: 'left' | 'right' | 'center' | null) => {
        if (nextAlign === null) {
          return;
        }
        onChange(nextAlign);
      }}
    >
      <ToggleButton size="small" value="left" aria-label="left aligned">
        <Tooltip title={capitalize(t('align.left'))}>
          <AlignLeft />
        </Tooltip>
      </ToggleButton>
      <ToggleButton size="small" value="center" aria-label="center aligned">
        <Tooltip title={capitalize(t('align.center'))}>
          <AlignCenter />
        </Tooltip>
      </ToggleButton>
      <ToggleButton size="small" value="right" aria-label="right aligned">
        <Tooltip title={capitalize(t('align.right'))}>
          <AlignRight />
        </Tooltip>
      </ToggleButton>
    </ToggleButtonGroup>
  );
};

export const TextAlignToggleButtonGroupWithLabel = ({
  value = 'left',
  onChange,
  fullWidth
}: {
  value?: 'left' | 'center' | 'right';
  onChange: (nextValue: 'left' | 'center' | 'right') => void;
  fullWidth?: boolean;
}) => {
  const { t } = useUnsafeTranslation();
  return (
    <CustomInputLabel label={capitalize(t('align.verb'))} fullWidth={fullWidth}>
      <TextAlignToggleButtonGroup value={value} onChange={onChange} />
    </CustomInputLabel>
  );
};
